import React from 'react';
import HelpSection from '../components/HelpSection/HelpSection';
import ProfessionalHealthPage from './ProfessionalHealthPage';

const HelpPage: React.FC = () => {
  return (
    <div className="help-page">
      <ProfessionalHealthPage />
    </div>
  );
};

export default HelpPage;
